// firestore
import { Env } from "@zickko/shared";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { clientConfig } from "../config/clientConfig";
import { firebaseApp } from "./firebaseApp";

// firebaseApps previously initialized using initializeApp()
export const firebaseFirestore = getFirestore(firebaseApp);

// emulator for local
if (clientConfig.env == Env.local) {
  console.log(`Connecting to local firestore emulator`);
  connectFirestoreEmulator(firebaseFirestore, "127.0.0.1", 8080);
}
